import { motion } from 'framer-motion';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { FiCheckCircle, FiGlobe, FiMail, FiMessageSquare, FiSend, FiTwitter, FiUser } from 'react-icons/fi';

const ContactPage = () => {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);
  const onChange = (e) => setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
    toast.success('Message sent!');
  };

  const contacts = [
    { icon: FiMail, label: 'Email', value: 'hello@sitevault.io', href: 'mailto:hello@sitevault.io' },
    { icon: FiTwitter, label: 'Twitter', value: '@sitevault', href: '#' },
    { icon: FiGlobe, label: 'Website', value: 'sitevault.io', href: '#' },
  ];

  return (
    <div className="section-tinted min-h-screen">
      <div className="container-main py-10 lg:py-14">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="mb-12">
          <div className="accent-line" />
          <p className="label-tag mb-2">Get In Touch</p>
          <h1 className="page-title">Contact Us</h1>
          <p className="section-subtitle max-w-lg">
            Have a question, suggestion, or want to partner with us? We'd love to hear from you.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-3 gap-8">
          <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.05 }} className="space-y-4">
            <div className="card p-6">
              <h3 className="font-extrabold text-slate-900 mb-1">Contact Info</h3>
              <p className="text-sm text-slate-600 mb-6">Reach us through any of these channels.</p>
              {contacts.map((c) => (
                <a key={c.label} href={c.href} className="flex items-center gap-3 p-3 rounded-xl hover:bg-slate-50 group transition-colors mb-1">
                  <div className="w-9 h-9 rounded-lg bg-indigo-50 flex items-center justify-center flex-shrink-0">
                    <c.icon size={16} className="text-indigo-600" />
                  </div>
                  <div>
                    <p className="text-xs font-bold text-slate-500 uppercase tracking-wider">{c.label}</p>
                    <p className="text-sm font-bold text-slate-800 group-hover:text-indigo-600 transition-colors">{c.value}</p>
                  </div>
                </a>
              ))}
            </div>
            <div className="card p-6 bg-indigo-50 border-2 border-indigo-100">
              <h3 className="font-extrabold text-slate-900 mb-2">Response Time</h3>
              <p className="text-sm text-slate-700 leading-relaxed">We typically respond within <strong>24–48 hours</strong> on business days.</p>
            </div>
          </motion.div>

          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="lg:col-span-2">
            {sent ? (
              <div className="card p-12 text-center">
                <div className="w-16 h-16 rounded-2xl bg-emerald-100 flex items-center justify-center mx-auto mb-4">
                  <FiCheckCircle size={28} className="text-emerald-600" />
                </div>
                <h2 className="text-xl font-extrabold text-slate-900 mb-2">Message Sent!</h2>
                <p className="text-slate-600 mb-6">We'll get back to you within 24–48 hours.</p>
                <button onClick={() => { setSent(false); setForm({ name: '', email: '', subject: '', message: '' }); }} className="btn-secondary">Send Another</button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="card p-6 lg:p-8 space-y-5">
                <div className="grid sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-bold text-slate-800 mb-1.5">Full Name</label>
                    <div className="relative">
                      <FiUser size={14} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" />
                      <input type="text" name="name" value={form.name} onChange={onChange} placeholder="John Doe" className="input-field pl-10" required />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-bold text-slate-800 mb-1.5">Email</label>
                    <div className="relative">
                      <FiMail size={14} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" />
                      <input type="email" name="email" value={form.email} onChange={onChange} placeholder="you@example.com" className="input-field pl-10" required />
                    </div>
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-bold text-slate-800 mb-1.5">Subject</label>
                  <input type="text" name="subject" value={form.subject} onChange={onChange} placeholder="How can we help?" className="input-field" required />
                </div>
                <div>
                  <label className="block text-sm font-bold text-slate-800 mb-1.5">Message</label>
                  <div className="relative">
                    <FiMessageSquare size={14} className="absolute left-3.5 top-4 text-slate-400" />
                    <textarea name="message" value={form.message} onChange={onChange} placeholder="Tell us more..." rows={6} className="input-field pl-10 resize-none" required />
                  </div>
                </div>
                <button type="submit" className="btn-primary w-full !py-3">
                  <FiSend size={14} /> Send Message
                </button>
              </form>
            )}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;